<mat-sidenav-container class="h-full w-full" [hasBackdrop]="false">
  <!-- Topic Sidenav -->
  <mat-sidenav
    #tagSidenav
    mode="side"
    [opened]="true"
    class="h-full border-r border-gray-200 bg-white"
    style="width: 200px"
  >
    <div class="flex h-full overflow-y-auto">
      <exam-ontology-domain-explorer
        [explorerNodes]="explorerNodes()"
        (selectedIdsChange)="onSelectedTagsChange($event)"
        (includeDependenciesChanged)="onIncludeDependenciesChanged($event)"
      ></exam-ontology-domain-explorer>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="relative h-full">
    <!-- Overlay for no selection -->
    @if (!hasSelectedTag()) {
      <div class="absolute inset-0 z-[500] flex flex-col items-center justify-center bg-white p-5 text-center">
        <dojo-icon [icon]="'arrow-pointer'" [size]="48" class="mb-4 text-neutral-300"></dojo-icon>
        <p class="text-lg font-medium text-neutral-500">Select a topic to view the ontology</p>
      </div>
    }

    <!-- Floating Action Buttons -->
    <div class="absolute bottom-[10px] left-[10px] z-[60] flex flex-col gap-2">
      <!-- Expand All -->
      <dojo-icon-button
        (click)="expandAllGroups()"
        class="rounded-lg bg-white shadow-sm"
        matTooltip="Expand all groups"
        [icon]="'expand'"
        [size]="'s'"
      ></dojo-icon-button>

      <!-- Collapse All -->
      <dojo-icon-button
        (click)="collapseAllGroups()"
        class="rounded-lg bg-white shadow-sm"
        matTooltip="Collapse all groups"
        [icon]="'compress'"
        [size]="'s'"
      ></dojo-icon-button>

      <!-- Toggle Sidebar -->
      <dojo-icon-button
        (click)="tagSidenav.toggle()"
        class="rounded-lg bg-white shadow-sm"
        [matTooltip]="tagSidenav.opened ? 'Hide Sidebar Tree' : 'Show Sidebar Tree'"
        [icon]="tagSidenav.opened ? 'arrow-left' : 'arrow-right'"
        [size]="'s'"
      ></dojo-icon-button>
    </div>

    <div class="graph-container relative h-full">
      <!-- Main Diagram Area -->
      <div class="diagram-wrapper relative h-full">
        <!-- Legend -->
        <div class="legend-container">
          <div class="legend-title">Legend</div>
          @for (typeConfig of nodeTypes; track typeConfig.type) {
            <div class="legend-item-wrapper">
              <button
                class="legend-item"
                (click)="onLegendClick(typeConfig.type)"
                [class.active]="highlightedLegendType() === typeConfig.type"
              >
                <span
                  class="legend-color"
                  [style.backgroundColor]="typeConfig.legendColor"
                  [style.borderColor]="typeConfig.legendBorderColor"
                ></span>
                <span>{{ typeConfig.label }}</span>
              </button>
            </div>
          }
          <!-- Collapsible Procedure Section -->
          <div class="legend-item-wrapper">
            <button class="legend-item procedure-toggle" (click)="toggleProcedureLegend()">
              <dojo-icon
                [icon]="procedureLegendExpanded() ? 'chevron-down' : 'chevron-right'"
                [size]="'xs'"
                class="text-gray-400"
              ></dojo-icon>
              <span>Procedure</span>
            </button>
          </div>
          @if (procedureLegendExpanded()) {
            <div class="procedure-categories">
              @for (cat of procedureCategories; track cat.category) {
                <button
                  class="legend-item procedure-category"
                  (click)="onProcedureCategoryClick(cat.category)"
                  [class.active]="highlightedProcedureCategory() === cat.category"
                >
                  <dojo-icon icon="arrow-right" [size]="'xs'" class="text-gray-400" matTooltip="Procedure"></dojo-icon>
                  <span class="legend-color" [style.backgroundColor]="cat.color"></span>
                  <span>{{ cat.label }}</span>
                </button>
              }
            </div>
          }
        </div>
        <!-- Diagram -->
        <div #myDiagramDiv class="diagram-div"></div>

        @if (myDiagram()) {
          <exam-gojs-overview [diagram]="myDiagram()!"></exam-gojs-overview>
        }
      </div>

      <!-- Resizable Overlay Panel -->
      @if (sidenavOpened() && selectedNode()) {
        <div class="absolute inset-y-0 right-0 z-[200] flex shadow-xl" [style.width.px]="detailsPanelWidth()">
          <!-- Resize Handle -->
          <div
            class="group relative flex w-1.5 cursor-col-resize items-center bg-gray-100 transition-colors hover:bg-blue-400"
            (mousedown)="onResizeStart($event)"
          >
            <div
              class="absolute left-1/2 h-8 w-1 -translate-x-1/2 rounded-full bg-gray-400 opacity-0 transition-opacity group-hover:opacity-100"
            ></div>
          </div>
          <!-- Panel Content -->
          <div class="h-full w-full overflow-hidden bg-white" (keydown.escape)="closeSidenav()">
            <exam-node-details
              class="block h-full w-full"
              [node]="selectedNode()!"
              [sourceProcedure]="sourceProcedure()"
              [sourceProcedures]="sourceProcedures()"
              [rootRepresentationIds]="rootRepresentationIds()"
              [runtimeState]="runtimeState()"
              [representationsMap]="representationsMap()"
              [tagsMap]="tagsMap()"
              (closePanel)="closeSidenav()"
              (navigateToNode)="onNavigateToNode($event)"
              (executeRoot)="executeRoot($event.id, $event.values)"
              (autoExecuteRoot)="handleAutoExecuteRoot()"
            ></exam-node-details>
          </div>
        </div>
      }
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
